import Store from '~store/store'
import ApolloClient, { ApolloQueryResult, FetchResult, MutationOptions, OperationVariables, QueryOptions } from 'apollo-boost'
import { ErrorResponse } from 'apollo-link-error'
import CONFIG from '~config/env'
import _ from 'lodash'
import { logout } from '@/plugins/loggedUser/loggedUser'
import Vue from 'vue'

const onError = ({ graphQLErrors, networkError }: ErrorResponse) => {
  if (
    graphQLErrors &&
    (graphQLErrors[0]?.message === 'jwt expired' || graphQLErrors[0]?.message.indexOf('permission denied for schema main') !== -1)
  ) {
    logout()
  } else if ((networkError || ({} as any))?.statusCode === 429) {
    Vue.toasted.error('Muitas requisições, tente novamente em alguns segundos')
  }
}

export const apolloClient = new ApolloClient({
  uri: CONFIG.API.GRAPHQL(),
  request: operation => {
    const token = localStorage.getItem('token')
    if (token) {
      operation.setContext({
        headers: {
          authorization: token ? `Bearer ${token}` : ''
        }
      })
    }
  },
  onError: _.debounce(onError, 100)
})

interface ExtendedQueryOptions<TVariables = OperationVariables> extends QueryOptions<TVariables> {
  loadingKey?: string
}

interface ExtendedMutationOptions<T = any, TVariables = OperationVariables> extends MutationOptions<T, TVariables> {
  loadingKey?: string
}

export interface ExtendedApollo {
  query<T = any, TVariables = OperationVariables>(options: ExtendedQueryOptions<TVariables>): Promise<ApolloQueryResult<T>>
  mutate<T = any, TVariables = OperationVariables>(options: ExtendedMutationOptions<T, TVariables>): Promise<FetchResult<T>>
}

export const query: ExtendedApollo['query'] = async options => {
  if (options.loadingKey) {
    Store.dispatch('startLoading', options.loadingKey)
  }
  try {
    return apolloClient.query(options).finally(() => {
      if (options.loadingKey) {
        Store.dispatch('endLoading', options.loadingKey)
      }
    })
  } catch (error) {
    if (options.loadingKey) {
      Store.dispatch('endLoading', options.loadingKey)
    }
    throw error
  }
}

export const mutate: ExtendedApollo['mutate'] = async options => {
  if (options.loadingKey) {
    Store.dispatch('startLoading', options.loadingKey)
  }
  try {
    return apolloClient.mutate(options).finally(() => {
      if (options.loadingKey) {
        Store.dispatch('endLoading', options.loadingKey)
      }
    })
  } catch (error) {
    if (options.loadingKey) {
      Store.dispatch('endLoading', options.loadingKey)
    }
    throw error
  }
}
